import { Link } from 'react-router-dom';
import type { Movie } from '@/types/content';

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-500"
    >
      <div className="relative w-full overflow-hidden" style={{ height: 260 }}>
        <img
          src={movie.cover}
          alt={movie.coverAlt}
          title={`${movie.title}剧情介绍`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-3 top-3 flex items-center gap-1.5 rounded-md bg-background-50/85 px-2 py-1 backdrop-blur">
          <i className="ri-star-fill text-xs text-accent-500"></i>
          <span className="text-xs font-semibold text-foreground-950">{movie.rating.toFixed(1)}</span>
        </div>
        <span className="absolute right-3 top-3 rounded-md bg-primary-500 px-2 py-1 text-xs font-semibold text-foreground-950">
          {movie.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="truncate font-heading text-base font-semibold text-foreground-950">{movie.title}</h3>
        <p className="mt-1.5 text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.genres.join(' / ')}
        </p>
        <p className="mt-3 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{movie.synopsis}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {movie.cast.slice(0, 3).map((name) => (
            <span key={name} className="rounded-full bg-secondary-200 px-2.5 py-1 text-xs text-secondary-950">
              {name}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}